// extracted by mini-css-extract-plugin
module.exports = {"root":"hero-module--root--1ID8S","low":"hero-module--low--2hVCa","caption":"hero-module--caption--27Ov8","captionTitle":"hero-module--captionTitle--1GWlO"};